import { createAction } from '@reduxjs/toolkit';

// eslint-disable-next-line import/prefer-default-export
export const setCurrentBatchRecord = createAction(
  'pilot/batch-records/SET_CURRENT_BATCH_RECORD',
  recordId => ({
    payload: recordId,
  })
);
